export default {
  "b2b.zakaznici-grid-columns.adresa.label": "Adresa",
  "b2b.zakaznici-grid-columns.ico.label": "IČO",
  "b2b.zakaznici-grid-columns.nazev.label": "Název"
};
